// react core
import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';

// compoents
import QuestionSummary from 'components/questions/question_summary';
import AjaxSpinner from 'components/commons/ajax_spinner';
import NoResults from 'components/questions/no_results';
import PaginatedItems from 'components/questions/paginator';
import ScrollToTop from 'components/commons/scroll_top';

// conf
import conf from 'conf/ajax';

// utils
import { get_questions } from 'commons/api';
import {
    page_params_parse,
    add_params_to_uri
} from 'commons/utils'
import usePageTitle from 'commons/page_title';

// state
import { StateContext } from 'store/state_context';

export default function QuestionsList(props)
{
    usePageTitle('Q&A');
    // parsing url
    // binding url change to data load
    const [response, set_data] = useState(null);
    const history = useLocation();

    const navigate = useNavigate();
    const on_pagination_click = (evt) =>
    {
        const data = add_params_to_uri({
            page: evt.page
        });
        navigate(data.url);
    };

    const { set_total_questions } = useContext(StateContext);

    useEffect(() =>
    {
        set_data(null);
        const url = new URL(window.location.href);
        const text = url.searchParams.get("text");
        const page = url.searchParams.get("page");
        const tag = url.searchParams.get("tag");
        const order_by = url.searchParams.get("order_by");
        const sort_by = url.searchParams.get("sort_by");
        const _pages = page_params_parse(window.location.href);
        let mounted = true;
        const fetchData = async () =>
        {
            const response =  await get_questions({
                text: text || '',
                filters: {
                    tag: tag || '',
                    order_by: order_by || '',
                    sort_by: sort_by || ''
                },
                page: _pages
            });
            const data = await response.json();
            if (mounted)
            {
                set_data(data);
                set_total_questions(data.total_questions);
            }
        }
        // call the function
        fetchData()
        // make sure to catch any error
        .catch(console.error);
        return () => mounted = false; // cleanup function
    }, [history.search, set_total_questions]);


    if(response !== null)
    {
        const items = response?.questions || null;
        if(items === null)
        {  
            return (
                <NoResults />
            );
        }
        if (items.length > 0) return (
            <>
                <ScrollToTop />
                <PaginatedItems
                    items_per_page={conf.request.step}
                    total_items={response?.total_questions || 0}
                    on_pagination_click={on_pagination_click}
                    cur_page={response.page}
                />
                <div className="questions-list-wrapper">
                {items.map(item => (
                    <QuestionSummary
                        key={item.id}
                        item={item}
                        searched_text={''}
                        highlight={true}
                        current_tag={null}
                    />
                ))}
                </div>
                <PaginatedItems
                    items_per_page={conf.request.step}
                    total_items={response?.total_questions || 0}
                    on_pagination_click={on_pagination_click}
                    cur_page={response.page}
                />
            </>
        );
        else return (
            <NoResults />
        );
    }
    else
    {
        return <AjaxSpinner />;
    }
}
